module.exports = __webpack_public_path__ + "media/pattern.43e4576e.mp4";